import { Injectable } from '@angular/core';
import { DateFormats } from '@constants/date-format.constants';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { ApiErrorsCopy } from '@models/cms/app-api-errors.model';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerGenericService {
  readonly DateFormats = DateFormats;
  environment = EnvironmentService.environment;

  readonly DEFAULT_KEY = 'default';

  getCopyByErrorKey(key: string, copy: ApiErrorsCopy): string {
    const [namespace, controller, errorCode] = key.split(':');

    const defaultErr = this.environment.production
      ? (copy[this.DEFAULT_KEY]?.[this.DEFAULT_KEY]?.[
          this.DEFAULT_KEY
        ] as string)
      : key;

    if (!namespace || !controller) {
      return defaultErr;
    }

    const result = (
      errorCode
        ? copy[namespace]?.[controller]?.[errorCode]
        : copy[namespace]?.[controller]
    ) as string;

    return result ?? defaultErr;
  }
}
